import { createContext } from "react";
import { emptyRentersNegative, IRentersNegativation } from "@/types/renters-negativation.type";

type InitialStateType = {
  negativation: IRentersNegativation
  saveNegativation: (renterData: IRentersNegativation) => Promise<{
    ok: boolean;
    data: IRentersNegativation;
    errors: Array<{
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      message: string | any;
      path: string[] | never[];
    }>;
  }>;
};

export const initialState: InitialStateType = {
  negativation: emptyRentersNegative(),
  saveNegativation: () => Promise.reject({
    ok: false,
    data: emptyRentersNegative(),
    errors: [{
      message: 'not-implemented',
      path: ['.']
    }]
  })
}
export const NegativationDashboardContext = createContext(initialState)